(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["customer-love"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const mount = (section) => {
      if (!section || section.dataset.loveReady === 'true') return;
      const track = section.querySelector('[data-love-track]');
      if (!track) return;
      section.dataset.loveReady = 'true';
      const controller = new AbortController();
      const { signal } = controller;
      const previous = section.querySelector('[data-love-previous]');
      const next = section.querySelector('[data-love-next]');
      const reducedMotion = matchMedia('(prefers-reduced-motion: reduce)');
      const step = () => {
        const card = track.querySelector('[data-love-card]');
        return card ? card.getBoundingClientRect().width + parseFloat(getComputedStyle(track).gap || 0) : track.clientWidth;
      };
      const update = () => {
        if (previous) previous.disabled = track.scrollLeft <= 2;
        if (next) next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 2;
      };
      const move = (direction) => track.scrollBy({ left: direction * step(), behavior: reducedMotion.matches ? 'auto' : 'smooth' });
      previous?.addEventListener('click', () => move(-1), { signal });
      next?.addEventListener('click', () => move(1), { signal });
      track.addEventListener('scroll', update, { passive: true, signal });
      track.addEventListener('keydown', (event) => {
        if (event.key === 'ArrowLeft') { event.preventDefault(); move(-1); }
        if (event.key === 'ArrowRight') { event.preventDefault(); move(1); }
      }, { signal });
      update();
      section.addEventListener('shopify:section:unload', () => { controller.abort(); delete section.dataset.loveReady; }, { once: true });
    };
    const scan = (root = document) => {
      if (root.matches?.('[data-customer-love]')) mount(root);
      root.querySelectorAll?.('[data-customer-love]').forEach(mount);
    };
    scan();
    document.addEventListener('shopify:section:load', (event) => scan(event.target));
    document.addEventListener('shopify:block:select', (event) => event.target.closest('[data-love-card]')?.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' }));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-products"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const mount = (section) => {
      if (!section || section.dataset.featuredProgressReady === 'true') return;
      const track = section.querySelector('.featured-products__grid');
      const progress = section.querySelector('[data-featured-scroll-progress]');
      const thumb = section.querySelector('[data-featured-scroll-thumb]');
      if (!track || !progress || !thumb) return;
      section.dataset.featuredProgressReady = 'true';

      const update = () => {
        const overflow = Math.max(track.scrollWidth - track.clientWidth, 0);
        progress.hidden = overflow < 2;
        if (progress.hidden) return;
        const visibleRatio = Math.min(track.clientWidth / track.scrollWidth, 1);
        const thumbWidth = Math.max(visibleRatio * progress.clientWidth, 42);
        const travel = Math.max(progress.clientWidth - thumbWidth, 0);
        const progressRatio = overflow > 0 ? Math.min(Math.max(track.scrollLeft / overflow, 0), 1) : 0;
        progress.style.setProperty('--featured-scroll-thumb-width', `${thumbWidth}px`);
        progress.style.setProperty('--featured-scroll-thumb-offset', `${travel * progressRatio}px`);
      };

      track.addEventListener('scroll', update, { passive: true });
      const observer = new ResizeObserver(update);
      observer.observe(track);
      Array.from(track.children).forEach((card) => observer.observe(card));
      update();
      section.addEventListener('shopify:section:unload', () => observer.disconnect(), { once: true });
    };

    const scan = (root = document) => {
      root.querySelectorAll?.('.featured-products').forEach(mount);
      if (root.matches?.('.featured-products')) mount(root);
    };

    scan();
    document.addEventListener('shopify:section:load', (event) => scan(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  if (!customElements.get('glow-header')) {
    class GlowHeader extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.dialog = this.querySelector('[data-mobile-dialog]');
        this.openButton = this.querySelector('[data-drawer-open]');
        this.closeButton = this.querySelector('[data-drawer-close]');
        this.desktopDisclosures = this.querySelectorAll('.navigation-links--desktop [data-navigation-disclosure]');
        this.handleOutsideClick = this.handleOutsideClick.bind(this);
        this.handleResize = this.handleResize.bind(this);
        this.stickyContainer = this.parentElement;
        this.stickyContainer?.classList.add('glow-header-sticky-container');

        this.openButton?.addEventListener('click', () => this.openDrawer());
        this.closeButton?.addEventListener('click', () => this.closeDrawer());
        this.dialog?.addEventListener('close', () => this.afterDrawerClose());
        this.dialog?.addEventListener('click', (event) => {
          if (event.target === this.dialog) this.closeDrawer();
        });

        this.dialog?.querySelectorAll('a[href]').forEach((link) => {
          link.addEventListener('click', () => this.closeDrawer(false));
        });

        this.desktopDisclosures.forEach((disclosure) => {
          disclosure.addEventListener('toggle', () => {
            if (!disclosure.open) return;
            this.desktopDisclosures.forEach((otherDisclosure) => {
              if (otherDisclosure !== disclosure) otherDisclosure.removeAttribute('open');
            });
          });
        });

        this.addEventListener('keydown', (event) => {
          if (event.key !== 'Escape') return;
          if (this.dialog?.open) {
            event.preventDefault();
            this.closeDrawer();
            return;
          }
          const openDisclosure = this.querySelector('.navigation-links--desktop details[open]');
          if (!openDisclosure) return;
          event.preventDefault();
          openDisclosure.removeAttribute('open');
          openDisclosure.querySelector('summary')?.focus();
        });

        document.addEventListener('click', this.handleOutsideClick);
        window.addEventListener('resize', this.handleResize);
      }

      disconnectedCallback() {
        document.removeEventListener('click', this.handleOutsideClick);
        window.removeEventListener('resize', this.handleResize);
      }

      openDrawer() {
        if (!this.dialog) return;
        this.previouslyFocused = document.activeElement;
        if (typeof this.dialog.showModal === 'function') {
          this.dialog.showModal();
        } else {
          this.dialog.setAttribute('open', '');
        }
        document.documentElement.classList.add('is-navigation-open');
        requestAnimationFrame(() => this.closeButton?.focus());
      }

      closeDrawer(restoreFocus = true) {
        if (!this.dialog?.hasAttribute('open')) return;
        this.shouldRestoreFocus = restoreFocus;
        if (typeof this.dialog.close === 'function') {
          this.dialog.close();
        } else {
          this.dialog.removeAttribute('open');
          this.afterDrawerClose();
        }
      }

      afterDrawerClose() {
        document.documentElement.classList.remove('is-navigation-open');
        if (this.shouldRestoreFocus !== false) this.previouslyFocused?.focus();
        this.shouldRestoreFocus = true;
      }

      handleOutsideClick(event) {
        if (this.contains(event.target)) return;
        this.desktopDisclosures.forEach((disclosure) => disclosure.removeAttribute('open'));
      }

      handleResize() {
        if (window.matchMedia('(min-width: 990px)').matches) this.closeDrawer(false);
      }
    }

    customElements.define('glow-header', GlowHeader);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shade-finder"] && !Shopify.designMode) return;
  try {
    
  const initializeGuidedShadeFinders = (scope = document) => {
    scope.querySelectorAll('[data-shade-finder]').forEach((finder) => {
      if (finder.dataset.initialized === 'true') return;
      finder.dataset.initialized = 'true';

      const steps = Array.from(finder.querySelectorAll('[data-shade-step]'));
      const progressItems = Array.from(finder.querySelectorAll('.shade-finder__progress li'));
      const nextButtons = Array.from(finder.querySelectorAll('[data-shade-next]'));
      const cards = Array.from(finder.querySelectorAll('[data-shade-card]'));
      const status = finder.querySelector('[data-shade-status]');
      const empty = finder.querySelector('[data-shade-empty]');
      const guide = finder.querySelector('[data-undertone-guide]');
      const guideOpen = finder.querySelector('[data-undertone-guide-open]');
      const guideClose = finder.querySelector('[data-undertone-guide-close]');
      const state = { step: 1, undertone: '', depth: '' };
      let guideReturnFocus = null;
      let selectionTimer = 0;
      const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

      const checkedValue = (name) => finder.querySelector(`input[name^="${name}-"]:checked`)?.value || '';
      const labelText = (name, value) => {
        const input = finder.querySelector(`input[name^="${name}-"][value="${value}"]`);
        return input?.nextElementSibling?.querySelector('strong')?.textContent.trim() || value;
      };

      const scrollStepActionIntoView = (step) => {
        const actionButton = step?.querySelector('[data-shade-next]');
        actionButton?.scrollIntoView({ behavior: reducedMotion.matches ? 'auto' : 'smooth', block: 'center' });
      };

      const updateButtons = () => {
        steps.forEach((step) => {
          const next = step.querySelector('[data-shade-next]');
          if (!next) return;
          const number = Number(step.dataset.shadeStep);
          if (number === 1) next.disabled = !state.undertone;
          if (number === 2) next.disabled = !state.depth;
        });
      };

      const renderResults = () => {
        let visibleCount = 0;
        cards.forEach((card) => {
          const matches = card.dataset.undertones.split('|').includes(state.undertone);
          card.hidden = !matches;
          if (matches) visibleCount += 1;
        });
        if (empty) empty.hidden = visibleCount > 0;
        if (status) {
          const template = visibleCount === 1 ? finder.dataset.resultOne : finder.dataset.resultOther;
          status.textContent = template.replace('__COUNT__', String(visibleCount)).replace('__UNDERTONE__', labelText('undertone', state.undertone));
        }
        finder.querySelector('[data-summary-undertone]').textContent = labelText('undertone', state.undertone);
        finder.querySelector('[data-summary-depth]').textContent = labelText('depth', state.depth);
      };

      const showStep = (number, shouldScroll = true) => {
        state.step = Math.max(1, Math.min(3, number));
        steps.forEach((step) => { step.hidden = Number(step.dataset.shadeStep) !== state.step; });
        progressItems.forEach((item, index) => {
          item.toggleAttribute('aria-current', index + 1 === state.step);
          if (index + 1 === state.step) item.setAttribute('aria-current', 'step');
          item.classList.toggle('is-complete', index + 1 < state.step);
        });
        if (state.step === 3) renderResults();
        if (shouldScroll) {
          finder.scrollIntoView({ behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start' });
        }
      };

      finder.addEventListener('change', (event) => {
        if (!(event.target instanceof HTMLInputElement)) return;
        state.undertone = checkedValue('undertone');
        state.depth = checkedValue('depth');
        updateButtons();
        window.clearTimeout(selectionTimer);
        if (event.target.name.startsWith('undertone-') && state.step === 1) {
          selectionTimer = window.setTimeout(() => scrollStepActionIntoView(steps[0]), 180);
        }
        if (event.target.name.startsWith('depth-') && state.step === 2) {
          selectionTimer = window.setTimeout(() => scrollStepActionIntoView(steps[1]), 180);
        }
      });

      guideOpen?.addEventListener('click', (event) => {
        if (!(guide instanceof HTMLDialogElement)) return;
        guideReturnFocus = event.currentTarget;
        guide.showModal();
      });
      guideClose?.addEventListener('click', () => guide?.close());
      guide?.addEventListener('click', (event) => {
        if (event.target === guide) guide.close();
      });
      guide?.addEventListener('cancel', (event) => {
        event.preventDefault();
        guide.close();
      });
      guide?.addEventListener('keydown', (event) => {
        if (event.key !== 'Escape') return;
        event.preventDefault();
        guide.close();
      });
      guide?.addEventListener('close', () => {
        guideReturnFocus?.focus();
        guideReturnFocus = null;
      });

      nextButtons.forEach((button) => button.addEventListener('click', () => showStep(state.step + 1)));
      finder.querySelectorAll('[data-shade-back]').forEach((button) => button.addEventListener('click', () => showStep(state.step - 1)));
      finder.querySelector('[data-shade-restart]')?.addEventListener('click', () => showStep(1));
      cards.forEach((card) => { card.hidden = true; });
      updateButtons();
      showStep(1, false);
    });
  };

  initializeGuidedShadeFinders();
  document.addEventListener('shopify:section:load', (event) => initializeGuidedShadeFinders(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ugc-video-slider"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const mount = (section) => {
      if (!section || section.dataset.sliderReady === 'true') return;
      const track = section.querySelector('[data-slider-track]');
      if (!track) return;
      section.dataset.sliderReady = 'true';
      const controller = new AbortController();
      const { signal } = controller;
      const previous = section.querySelector('[data-slider-previous]');
      const next = section.querySelector('[data-slider-next]');
      const videos = Array.from(section.querySelectorAll('video'));
      const reducedMotion = matchMedia('(prefers-reduced-motion: reduce)');
      const step = () => {
        const card = track.querySelector('[data-slider-card]');
        return card ? card.getBoundingClientRect().width + parseFloat(getComputedStyle(track).gap || 0) : track.clientWidth;
      };
      const update = () => {
        if (previous) previous.disabled = track.scrollLeft <= 2;
        if (next) next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 2;
      };
      const move = (direction) => track.scrollBy({ left: direction * step(), behavior: reducedMotion.matches ? 'auto' : 'smooth' });
      previous?.addEventListener('click', () => move(-1), { signal });
      next?.addEventListener('click', () => move(1), { signal });
      track.addEventListener('scroll', update, { passive: true, signal });
      track.addEventListener('keydown', (event) => {
        if (event.key === 'ArrowLeft') { event.preventDefault(); move(-1); }
        if (event.key === 'ArrowRight') { event.preventDefault(); move(1); }
      }, { signal });
      videos.forEach((video) => video.addEventListener('play', () => videos.forEach((other) => { if (other !== video) other.pause(); }), { signal }));
      const observer = new IntersectionObserver((entries) => entries.forEach((entry) => { if (!entry.isIntersecting) entry.target.pause(); }), { root: track, threshold: 0.35 });
      videos.forEach((video) => observer.observe(video));
      update();
      section.addEventListener('shopify:section:unload', () => { controller.abort(); observer.disconnect(); delete section.dataset.sliderReady; }, { once: true });
    };
    const scan = (root = document) => {
      if (root.matches?.('[data-ugc-slider]')) mount(root);
      root.querySelectorAll?.('[data-ugc-slider]').forEach(mount);
    };
    scan();
    document.addEventListener('shopify:section:load', (event) => scan(event.target));
    document.addEventListener('shopify:block:select', (event) => event.target.closest('[data-slider-card]')?.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' }));
  })();

  } catch(e) { console.error(e); }
})();
})();
